export default __webpack_public_path__ + "static/media/student-registration.c9de6762.svg";